import { EntityType } from '@frontend/common';

/** Options for a single resolve request. */
export type ResolveOptions = {
    /**
     * Skip the resolver batch debounce and the initial awaitResolve delay.
     * Use for detail panes that should fetch as soon as they open.
     */
    skipTimeout?: boolean;
};

/**
 * A resolve function asks the app-level resolver for a single entity and returns the
 * localStorage key that flips to `false` once the batched resolve call has finished.
 */
export type ResolveFunction = (id: string, options?: ResolveOptions) => string;

const resolveFunctions = new Map<EntityType, ResolveFunction>();

/**
 * Called by `useResolver` so that consumers which only know an `EntityType` — reactive list
 * rows, for example — can resolve an entity without importing the domain `events` library.
 *
 * Several group resolvers share `EntityType.MEMBER`; for those the last mounted resolver wins,
 * mirroring how they already share a single bucket in the resolve cache. Pass an explicit
 * resolve function when that ambiguity matters.
 */
export function registerResolveFunction(type: EntityType, resolveFunction: ResolveFunction): void {
    resolveFunctions.set(type, resolveFunction);
}

export function getResolveFunction(type: EntityType): ResolveFunction | undefined {
    return resolveFunctions.get(type);
}
